module.exports = __webpack_public_path__ + "static/media/Octicons2.724ac46b.ttf";